// extracted by mini-css-extract-plugin
export default {"sidebar":"SideBar_sidebar__TQVHb","sidebar-container":"SideBar_sidebar-container__V2GFP","logo":"SideBar_logo__KQG0O"};